import JSONData from "../variables/variables.json";
import classNames from "classname";
import Image from "next/image";
import TranslatedMessage from "./TranslatedMessage";

const Banner = (props) => {
	// PROPS VARIABLE
	let propsMiasto = props.miasto;
	let propsPodatek = props.podatek;
	let propsAuthor = props.author;

	let banner = "banner";

	let miastoVariable = "miasta." + propsMiasto;

	// SLIDER HEADER
	let headerTitle =
		miastoVariable + "." + banner + "." + [propsPodatek] + "." + [propsAuthor] + ".header.title";

	let headerDescription =
		miastoVariable +
		"." +
		banner +
		"." +
		[propsPodatek] +
		"." +
		[propsAuthor] +
		".header.description";

	// JSON VARIABLE
	let miastoJSON = JSONData.miasta[propsMiasto];

	let witryna = miastoJSON.witryna;

	let bannerImg = miastoJSON.banner[propsPodatek][propsAuthor].header.images.url;

	const Banner = (props) => (
		<section
			className={classNames("pd-banner", {
				small: props.small,
			})}
		>
			<div className="pd-banner__wrapper">{props.children}</div>
		</section>
	);

	const BannerTitle = (props) => (
		<h1 className="pd-banner__header__title" id={props.id}>
			{props.children}
		</h1>
	);

	const BannerDescription = (props) => (
		<p className="pd-banner__header__subtitle">{props.children}</p>
	);

	const BannerImage = (props) => <div className="pd-banner__image">{props.children}</div>;

	const BannerAction = (props) => <div className="pd-banner__action">{props.children}</div>;

	return (
		<>
			<Banner small={props.small}>
				<BannerTitle>
					<TranslatedMessage id={headerTitle} />
				</BannerTitle>
				<BannerImage>
					<Image unoptimized 
						alt=""
						src={bannerImg}
						width="740"
						height="740"
						quality={100}
						priority
						style={{
							width: "100%",
							height: "auto",
						}}
					/>
				</BannerImage>
				<BannerDescription>
					<TranslatedMessage id={headerDescription} />
				</BannerDescription>
				<BannerAction></BannerAction>
			</Banner>
		</>
	);
};

export default Banner;
